import type { KatalogResponse, User } from '../../lib/api.js';
import type { ProtokollSession } from '../../lib/state.js';

/** Kontext, den jeder Wizard-Schritt erhält. */
export interface WizardCtx {
  p: ProtokollSession;
  katalog: KatalogResponse;
  user: User;
  /** Summen/Kopfzeile/Stepper aktualisieren (nach jeder Wertänderung) */
  recalc(): void;
  /** Debounced-Autosave anstoßen */
  save(): void;
  /** Aktuellen Schritt neu zeichnen (nach Strukturänderungen) */
  rerender(): void;
  /** Zu einem Schritt springen */
  go(step: number): void;
}

export const STEPS = [
  'Grunddaten',
  'Laube',
  'Nebenanlagen',
  'Kulturen',
  'Zierbegrünung',
  'Ergebnis',
  'Abschluss',
] as const;
